import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from 'drift-ui';
import { useTranslation } from 'react-i18next';
import { DriftIcons } from 'drift-ui';
import { DO_APPLICATION_TYPE } from 'client-experience-toolbox';
const { CloseIcon } = DriftIcons;

interface ExitConfirmationDialogProps {
  open: boolean;
  applicationType: DO_APPLICATION_TYPE;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ExitConfirmationModal: FC<ExitConfirmationDialogProps> = ({
  open,
  applicationType,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      aria-labelledby={t('digital_onboarding.close_application_title')}
      aria-describedby={t(`digital_onboarding.close_application_text_${applicationType.toLowerCase()}`)}
    >
      <DialogTitle id="close-application-title" data-testid="close-application-title">
        {t('digital_onboarding.close_application_title')}
      </DialogTitle>
      <IconButton
        aria-label={t('Cancel')}
        onClick={onCancel}
        sx={{
          position: 'absolute',
          right: 24,
          top: 18,
          color: (theme) => theme.palette.gray[700],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minWidth: '552px' }}>
        <DialogContentText>
          {t(`digital_onboarding.close_application_text_${applicationType.toLowerCase()}`)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel} data-testid="cancel-application-button">
          {t('Cancel')}
        </Button>
        <Button variant="contained" onClick={onConfirm} autoFocus data-testid="close-application-button">
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExitConfirmationModal;
